
































import { Component, Vue } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { DomainTipResponse } from '@/interfaces'
import store from '@/store'

@Component({
  components: {
    PageHead,
  },
})
export default class IndexPage extends Vue {
  pageTitle = 'Admin Home'
  callInProgress = false
  DomainTipResponse = null
  showHelpGuide = false

  mounted() {
    this.fetchDashboardTip()
    this.showHelpGuidePopUp()
  }

  public async fetchDashboardTip() {
    this.callInProgress = true
    try {
      this.DomainTipResponse = await Api.getDashboardTip()
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public showHelpGuidePopUp() {
    // console.log(store.getters.showHelpGuide)
    if (store.getters.showHelpGuide) {
      this.$bvModal.show('modal-help-guide')
    }
  }

  public toggleHelpGuideDisplayChoice() {
    store.commit('toggleFlag', 'showHelpGuide')
    // console.log(store.getters.showHelpGuide)
  }
}
